import { OwcBadge, OwcButton, OwcTypography } from "@one/react";

const BulkRemovalSummary = ({ rowsCount, onBatchRemovalClick, containerStyle }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, ...(containerStyle || {}) }}>
      <OwcBadge
        type="active"
        style={{
          width: "24px",
          height: "24px",
        }}
      >
        {rowsCount}
      </OwcBadge>
      <OwcTypography>
        row{rowsCount === 1 ? "" : "s"} will be removed
      </OwcTypography>
      <OwcButton
        variant="primary"
        disabled={!rowsCount}
        onClick={onBatchRemovalClick}
      >
        Batch removal
      </OwcButton>
    </div>
  );
};

export default BulkRemovalSummary;